import React, { useMemo } from 'react'
import classnames from 'classnames'
import PropTypes from 'prop-types'

import { dateFormatter } from 'helpers'

const PADDING_CLASS = 'px-2 py-1'

const Td = ({ className, children }) => (
  <td className={classnames(className, PADDING_CLASS, 'border-solid border border-opacity-20')}>
    {children}
  </td>
)

const EventDetails = ({ event, eventLink, user, classNames }) => {
  const details = useMemo(() => {
    const eventDate = dateFormatter.convertServerDateToLocalTimeZone(event.startTime)
    const { month, eventDay, eventCardTime } = dateFormatter.generateEventCardTime(eventDate)

    return [
      {
        label: 'Title',
        value: event.title,
      },
      {
        label: 'Host',
        value: user.Host?.name,
      },
      {
        label: 'Date',
        value: `${month} ${eventDay}`,
      },
      {
        label: 'Time',
        value: eventCardTime,
      },
      {
        label: 'ID',
        value: event.id,
      },
      {
        label: 'Slug',
        value: event.slug,
      },
      {
        label: 'Link',
        value: eventLink,
      },
      {
        label: 'Sexual Orientation',
        value: event.sexualOrientation,
      },
      {
        label: 'Location',
        value: event.location,
      },
      {
        label: 'Format',
        value: event.eventFormat,
      },
      {
        label: 'Visibility',
        value: event.eventVisibility,
      },
    ]
  }, [event, user, eventLink])

  return (
    <div className="px-2 py-2 text-sm">
      <table className="table-auto">
        <tbody>
          {details.map(({ label, value }, index) => (
            <tr key={index}>
              <Td className={classnames('font-semibold', classNames.td)}>{label}</Td>
              <Td className={classNames.td}>{value}</Td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  )
}

EventDetails.propTypes = {
  event: PropTypes.shape({
    id: PropTypes.number,
    slug: PropTypes.string,
    title: PropTypes.string,
    startTime: PropTypes.string,
    sexualOrientation: PropTypes.string,
    location: PropTypes.string,
    eventFormat: PropTypes.string,
    eventVisibility: PropTypes.string,
  }),
  eventLink: PropTypes.string,
  user: PropTypes.shape({
    Host: PropTypes.shape({
      name: PropTypes.string,
    }),
  }),
  classNames: PropTypes.shape({
    td: PropTypes.string,
  }),
}

export default EventDetails
